import { useDedaloApi } from '@/hooks/api/useDedaloApi';
import { FragmentSchema, AudiovisualSchema } from '@/schemas/fragmentSchema';

export function useFragment(locator) {
    const options = locator
        ? {
            dedalo_get: 'fragment_from_index_locator',
            index_locator: JSON.stringify(locator),
        }
        : null;

    return useDedaloApi(options);
}

export function useAudiovisual(id) {
    const options = {
        table: 'audiovisual',
        section_id: id,
        ar_fields: ['title'],
    };

    return useDedaloApi(options, AudiovisualSchema);
}